export const BAR_HEIGHT = 20;
export const ITEM_GAP = 8;
export const GROUP_GAP = 24;
export const LABEL_COLUMN_WIDTH = 24;
export const ROLE_GAP = 8;
export const TRACK_OFFSET = LABEL_COLUMN_WIDTH + ROLE_GAP;
export const ITEM_HEIGHT = 16 + ITEM_GAP + BAR_HEIGHT;
export const CONTENT_BOTTOM_PADDING = 12;
export const MIN_HOVER_PCT = 3;

export const TRACK_BG = "#E8ECF0";
export const FILL_COLOR_ACTIVE = "#778AA7";
export const DASH_COLOR = "#797979";
export const DIVIDER_COLOR = "#e5e7eb";
export const GAP_COLOR = "#CF3E00";
export const EXTRA_COLOR = "#27AE60";

export const hatchBackground = (color: string) =>
  `repeating-linear-gradient(45deg, ${color} 0px, ${color} 1px, transparent 1px, transparent 4px)`;

export const getNiceTicks = (max: number): number[] => {
  if (max <= 0) return [0, 1];
  const rawStep = max / 5;
  const magnitude = Math.pow(10, Math.floor(Math.log10(rawStep)));
  const residual = rawStep / magnitude;
  let step: number;
  if (residual > 5) step = 10 * magnitude;
  else if (residual > 2) step = 5 * magnitude;
  else if (residual > 1) step = 2 * magnitude;
  else step = magnitude;
  step = Math.max(step, 1);

  const niceMax = Math.ceil(max / step) * step;
  const ticks: number[] = [];
  for (let v = 0; v <= niceMax + 1e-9; v += step) {
    ticks.push(Math.round(v));
  }
  return ticks;
};

export const buildPopperModifiers = (boundary: HTMLElement | null) => [
  {
    name: "preventOverflow",
    options: {
      boundary: boundary || "clippingParents",
      altAxis: true,
      padding: { left: 8, right: 8, top: 8, bottom: 8 },
    },
  },
  {
    name: "flip",
    options: {
      boundary: boundary || "clippingParents",
      fallbackPlacements: ["bottom"],
    },
  },
];
